import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import API from '../api/axios';

export default function DonateCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Confirming your donation...');

  useEffect(() => {
    const status = searchParams.get('status');
    const txRef = searchParams.get('tx_ref');

    if (status === 'cancelled') {
      setMessage('Donation cancelled.');
      setTimeout(() => navigate('/donate'), 2000);
      return;
    }

    if (status === 'successful' && txRef) {
      API.post('/api/billing/donate/verify', { tx_ref: txRef })
        .then(() => {
          setMessage('Thank you for your donation! ❤️');
          setTimeout(() => navigate('/settings'), 2500);
        })
        .catch(() => {
          setMessage('We could not confirm your donation. Contact support if you were charged.');
          setTimeout(() => navigate('/settings'), 3000);
        });
    } else {
      setMessage('Donation was not completed.');
      setTimeout(() => navigate('/donate'), 2000);
    }
  }, [navigate, searchParams]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      gap: '16px',
      textAlign: 'center',
      padding: '0 24px',
    }}>
      <p style={{ fontSize: '18px' }}>{message}</p>
    </div>
  );
}